import React from 'react';
import './style.css';
import '../../Assests/Globalcss/stylesheet.css'
import Footer from '../../Componenets/Footer'
const PrivacyPolicy = () => {
  return (
    <>
    <section className="hand-made-section">
    <div className="container">
      <div className="row d-flex justify-content-center align-items-center">
        <div className="col-lg-8">
          <div className="content-hand-made text-center">
            <h1 style={{marginTop:59}}>Privacy Policy!</h1>
            {/* <h1>Pure. Handmade. Nature's Best for Your Skin!</h1> */}
       
          </div>
        </div>
      </div>
    </div>
  </section>
    <div className="privacy-container">
        

      <section className="privacy-intro">
        <p>
          At <strong>MY FAVORITE THINGS</strong>: Your privacy is very important to us. This Privacy Policy outlines how we collect, use, and protect your personal information when you interact with our website.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Information We Collect</h2>
        <p>We may collect the following personal information:</p>
        <ul className="privacy-list">
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Billing and shipping addresses</li>
          <li>Payment information (processed securely via trusted third-party services)</li>
          <li>Any information you share with us when contacting customer service</li>
        </ul>
        <p>
          We also collect non-personal data such as your IP address, browser type, and pages visited to enhance your experience and improve our services.
        </p>
      </section>

      <section className="privacy-section">
        <h2>How We Use Your Information</h2>
        <p>Your information may be used to:</p>
        <ul className="privacy-list">
          <li>Process and fulfill your orders</li>
          <li>Send order confirmations and shipping updates</li>
          <li>Respond to your inquiries and provide customer support</li>
          <li>Improve our website and product offerings</li>
          <li>Share promotional content (only if you subscribe)</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>Sharing Your Information</h2>
        <p>
          We do not sell or rent your personal data. We may share limited information with reliable third-party service providers to assist with:
        </p>
        <ul className="privacy-list">
          <li>Payment processing</li>
          <li>Order shipping and delivery</li>
          <li>Website hosting and analytics</li>
          <li>Email communication (with your consent)</li>
        </ul>
        <p>
          These providers are required to keep your data secure and use it only for the services they perform on our behalf.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Security of Your Data</h2>
        <p>
          We prioritize your data security and use encryption, firewalls, and secure servers to protect it. However, no online platform is completely risk-free, so we encourage you to safeguard your own login and payment information.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Use of Cookies</h2>
        <p>Our website may use cookies to:</p>
        <ul className="privacy-list">
          <li>Understand user behavior</li>
          <li>Improve website functionality</li>
          <li>Provide a more personalized shopping experience</li>
        </ul>
        <p>
          You may disable cookies via your browser settings, but doing so could affect some site features.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Your Rights</h2>
        <p>You have the right to:</p>
        <ul className="privacy-list">
          <li>Access the data we hold about you</li>
          <li>Request correction or deletion of your personal information</li>
          <li>Withdraw consent for marketing communications</li>
        </ul>
        <p>To exercise these rights, please contact us using the details below.</p>
      </section>

      <section className="privacy-section">
        <h2>Changes to This Privacy Policy</h2>
        <p>
          We may revise this Privacy Policy from time to time. Any updates will be posted on this page with a new "Effective Date."
        </p>
      </section>

      <section className="privacy-contact">
        <h2>Contact Us</h2>
        <p>If you have any questions or concerns about this Privacy Policy, please reach out to us at:</p>
        <address>
          <strong>MY FAVORITE THINGS by CAROLYN MARTIN</strong><br />
          📍 212 Shirlwood Drive, Schenectady, NY 12306<br />
          📞 Phone: <a href="tel:518-937-5177">518-937-5177</a><br />
          📧 Email: <a href="mailto:crystlsviola@gmail.com">crystlsviola@gmail.com</a><br />
          🌐 <a href="https://things.farhanali.design">https://things.farhanali.design</a>
        </address>
      </section>
    </div>
    <Footer/>
    </>
  );
};

export default PrivacyPolicy;